<footer class="ui-form-action-footer" [class.ui-form-action-footer--split]="usesSplitLayout()">
  @if (usesSplitLayout()) {
    <div class="ui-form-action-footer__left">
      @if (showBack()) {
        <ui-button variant="secondary" [disabled]="disableBack()" [ariaLabel]="backLabel() | uiLabelTranslate" (click)="onBackClicked()">
          {{ backLabel() | uiLabelTranslate }}
        </ui-button>
      }
    </div>

    <div class="ui-form-action-footer__right">
      @if (showSave()) {
        <ui-button
          [disabled]="disableSave() || isSaving()"
          [ariaLabel]="isSaving() ? 'Saving...' : (saveLabel() | uiLabelTranslate)"
          (click)="onSaveClicked()"
        >
          {{ saveLabel() | uiLabelTranslate }}
        </ui-button>
      }
      @if (showNext()) {
        <ui-button variant="secondary" [disabled]="disableNext()" [ariaLabel]="nextLabel() | uiLabelTranslate" (click)="onNextClicked()">
          {{ nextLabel() | uiLabelTranslate }}
        </ui-button>
      }
    </div>
  } @else {
    <div class="ui-form-action-footer__right ui-form-action-footer__right--clustered">
      @if (showBack()) {
        <ui-button variant="secondary" [disabled]="disableBack()" [ariaLabel]="backLabel() | uiLabelTranslate" (click)="onBackClicked()">
          {{ backLabel() | uiLabelTranslate }}
        </ui-button>
      }
      @if (showSave()) {
        <ui-button
          [disabled]="disableSave() || isSaving()"
          [ariaLabel]="isSaving() ? 'Saving...' : (saveLabel() | uiLabelTranslate)"
          (click)="onSaveClicked()"
        >
          {{ saveLabel() | uiLabelTranslate }}
        </ui-button>
      }
      @if (showNext()) {
        <ui-button variant="secondary" [disabled]="disableNext()" [ariaLabel]="nextLabel() | uiLabelTranslate" (click)="onNextClicked()">
          {{ nextLabel() | uiLabelTranslate }}
        </ui-button>
      }
    </div>
  }
</footer>
